import React from "react";
import { StyledPedagogyTile } from "./_styled";

export default function practicePointProcessor() {
  const processPracticePoint = (options) => {
    const { children, wrapperNode, processNodes, practicePoint } = options;
    const { title, info } = practicePoint;
    const content = processNodes(wrapperNode, children);
    return (
      <StyledPedagogyTile
        barColor="accent"
        title={title}
        description={content}
        info={info}
        glyph="stethoscope"
      />
    );
  };

  return { processPracticePoint };
}
